/*************************************************/
/* COOKIES (UserCentrics via GTM)                */
/*************************************************/

export function cookies() {
    const cookiePlaceholderSelector = '.cookie-placeholder';
    const placeholderSelectors = Array.from(document.querySelectorAll(cookiePlaceholderSelector));

    window.RenewConsent = () => {
        // Access the shadow root of the element containing the consent button
        const shadowRoot = document.querySelector('#usercentrics-cmp-ui').shadowRoot;

        if (shadowRoot) {
            // Select the button inside the shadow DOM
            const getConsentButton = shadowRoot.querySelector('#uc-privacy-button');

            if (getConsentButton && getConsentButton.offsetParent !== null) { // Ensure button is visible
                getConsentButton.click(); // Click the consent button
            }
        }
    };

    const SetPlaceholderDisplayState = (placeholder, displayState) => {
        placeholder.style.display = displayState;
    };

    const GetConsentData = () => {
        // Reverse the dataLayer to get the latest event first
        const consentData = [...window.dataLayer].reverse().find(item => item.event === "consent_status");

        if (!consentData || !consentData.ucCategory) {
            return { marketing: false, statistics: false, preferences: false };
        }

        return {
            marketing: Boolean(consentData.ucCategory.marketing),
            statistics: Boolean(consentData.ucCategory.statistics),
            preferences: Boolean(consentData.ucCategory.preferences)
        };
    };

    const ApplyConsent = () => {
        const consentData = GetConsentData();

        document.querySelectorAll('[data-categories*="marketing"]').forEach(placeholder => {
            SetPlaceholderDisplayState(placeholder, consentData.marketing ? 'none' : 'flex');
        });

        document.querySelectorAll('[data-categories*="statistics"]').forEach(placeholder => {
            SetPlaceholderDisplayState(placeholder, consentData.statistics ? 'none' : 'flex');
        });

        document.querySelectorAll('[data-categories*="preferences"]').forEach(placeholder => {
            SetPlaceholderDisplayState(placeholder, consentData.preferences ? 'none' : 'flex');
        });
    };

    const SetPlaceholderState = () => {
        ApplyConsent();

        // ✅ Listen for future consent updates from GTM
        window.addEventListener("load", () => {
            const observer = new MutationObserver(() => ApplyConsent());
            observer.observe(document.body, { childList: true, subtree: true });
        });
    };

    // ✅ Initialize placeholders and event listeners
    const init = () => {
        SetPlaceholderState();

        for (const placeholderSelector of placeholderSelectors) {
            placeholderSelector.addEventListener('click', event => {
                let placeholder = event.target;
                if (!placeholder.classList.contains(cookiePlaceholderSelector)) {
                    placeholder = event.target.closest(cookiePlaceholderSelector);
                }
                event.stopPropagation();
                RenewConsent();
            });
        }
    };

    init();
}
